import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { GeneralLedger } from '../components/finance/GeneralLedger';

export const Finance = () => {
  const { t, language } = useLanguage();

  return (
    <div className="p-4 md:p-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <h1 className="text-2xl md:text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="finance-title">
        {t('finance')}
      </h1>
      <GeneralLedger />
    </div>
  );
};
